let SignTypedDataVersion = /*#__PURE__*/function (SignTypedDataVersion) {
  SignTypedDataVersion["V1"] = "V1";
  SignTypedDataVersion["V3"] = "V3";
  SignTypedDataVersion["V4"] = "V4";
  return SignTypedDataVersion;
}({});

export { SignTypedDataVersion };
